import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { Button } from "../../components/atoms";
import { RocketIcon } from "../../components/atoms/icons/RocketIcon";
import { LayeredCircles } from "../../components/atoms/LayeredCircles";
import { ModalWrapper } from "../ModalProvider";

export const OnboardingCompleteModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <ModalWrapper onCancel={onClose}>
      <div className="flex w-full flex-col items-center gap-6 p-4 pb-2 pt-8">
        <div className="flex flex-col items-center gap-4">
          <LayeredCircles intent="secondary">
            <RocketIcon className="stroke-secondary-500" />
          </LayeredCircles>
          <div className="flex flex-col items-center gap-1.5">
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.3 }}
              className="text-secondary-500 text-center text-xl font-bold"
            >
              {t("pages.onboarding.completed")}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.3 }}
              className="whitespace-pre text-center text-base font-medium text-gray-500"
            >
              {t("pages.onboarding.completedDescription")}
            </motion.div>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.3 }}
          className="w-full"
        >
          <Button intent="secondary" className="w-full" onClick={onClose}>
            {t("pages.onboarding.gotIt")}
          </Button>
        </motion.div>
      </div>
    </ModalWrapper>
  );
};
